module.exports = __webpack_public_path__ + "static/media/cloud.c30f845c.png";